module.exports = __webpack_public_path__ + "img/PL00103.14f565b3.svg";